export default __webpack_public_path__ + "static/media/ribbon.0fb11d30.svg";